// components/MinhaConta.styles.ts

import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  root: {
    maxWidth: 600,
    mx: 'auto',
    px: 2,
    py: 4,
  },
  section: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    p: 3,
    mb: 2,
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: 2,
    boxShadow: 'none',
    backgroundColor: '#fff',
  },
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    pr: 2,
  },
  label: {
    fontWeight: 'bold',
    mb: 0.5,
  },
  value: {
    color: 'text.primary',
  },
  description: {
    color: 'text.secondary',
    fontSize: '0.875rem',
    mt: 0.5,
  },
  button: {
    textTransform: 'none',
    borderRadius: 20,
    px: 3,
    py: 1,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  warningBox: {
    display: 'flex',
    alignItems: 'center',
    mt: 1,
  },
  warningIcon: {
    mr: 1,
    color: 'warning.main',
  },
};
